import {observer} from "mobx-react";
import {
    fmsDocumentPrinterStore,
    FmsPrinterSelectDialogStoreInterface,
    fmsVlogPrinterStore,
    isStorageTransferOrInternalProcess
} from "../../../store";
import {DialogAction} from "@kroschke/react-ui";
import {FieldAutoComplete, FieldSelect, ModalDialog} from "../../ui";
import {FmsCustomerItem, fmsCustomerStore} from "../../../store/fms/FmsCustomerStore";
import {ShipmentProcessTypeDto} from "../../../api/fms";
import {displayShipmentProcessType} from "../../../api";

const processOptions = Object.keys(ShipmentProcessTypeDto).map(key => key as ShipmentProcessTypeDto).map(key => ({
    label: displayShipmentProcessType(key),
    value: key
}))

interface FmsPackageFinishBatchDialogProps {
    store: FmsPrinterSelectDialogStoreInterface,
    title: string;
    okLabel: string;
    action: (store: FmsPrinterSelectDialogStoreInterface) => Promise<any>;

}

const FmsPackageFinishBatchDialog = observer(function FmsPackageFinishBatchDialog({
                                                                      store,
                                                                      title,
                                                                      okLabel,
                                                                      action
                                                                  }: FmsPackageFinishBatchDialogProps) {

    const dialogActions: DialogAction[] = [
        {
            label: "Abbrechen",
            execute: async function () {
                store.dialogOpen = false
            },
            className: 'is-rounded is-small'
        }
    ]

    const labelPrinterSelect = !isStorageTransferOrInternalProcess(store.processType)
    const addOk = labelPrinterSelect
        ? Boolean(store.labelPrinter && store.documentPrinter)
        : Boolean(store.documentPrinter)

    if (addOk) {
        dialogActions.push({
            label: okLabel,
            executing: store.executing,
            execute: async function () {
                store.executing = true
                await action(store)
                store.executing = false
            },
            className: 'is-primary is-rounded is-small'
        })
    }

    return <ModalDialog
        titleCloseable={false}
        store={store}
        actions={dialogActions}
        title={title}
    >
        <div className={'columns'}>
            <div className={'column is-half'}>
                <FieldSelect
                    label={'Prozess'}
                    options={processOptions}
                    value={store.processType}
                    required={true}
                    onChange={e => {
                        store.processType = e as ShipmentProcessTypeDto
                    }}
                />
            </div>
            <div className={'column is-half'}>
                <FieldAutoComplete
                    label={"Kunde"}
                    value={store.customer}
                    options={fmsCustomerStore.items}
                    itemRenderer={c => c.label || c.id}
                    search={v => fmsCustomerStore.search(v)}
                    onChange={(v: FmsCustomerItem | undefined) => {
                        store.customer = v
                    }}
                />
            </div>
        </div>
        <div className={'columns'}>
            <div className={`column ${labelPrinterSelect? 'is-half' : 'is-full'}`}>
                <FieldAutoComplete
                    label={"Dokumentendrucker"}
                    help={"Bitte wähle den zu verwendenden Drucker"}
                    required={true}
                    disabled={!store.customer}
                    itemRenderer={c => c.label}
                    options={fmsDocumentPrinterStore.options}
                    search={async (v) => {
                        await fmsDocumentPrinterStore.find(v)
                        return fmsDocumentPrinterStore.options
                    }}
                    value={store.documentPrinter}
                    onChange={v => {
                        store.documentPrinter = v
                    }}
                />
            </div>
            {labelPrinterSelect && <div className={`column is-half`}>
                <FieldAutoComplete
                    label={"Versandlabeldrucker"}
                    help={"Bitte wähle den zu verwendenden Drucker"}
                    required={true}
                    disabled={!store.customer}
                    itemRenderer={c => c.label}
                    options={fmsVlogPrinterStore.options}
                    search={async (v) => {
                        await fmsVlogPrinterStore.find(v)
                        return fmsVlogPrinterStore.options
                    }}
                    value={store.labelPrinter}
                    onChange={v => {
                        store.labelPrinter = v
                    }}
                />
            </div>}
        </div>
    </ModalDialog>
})

export {
    FmsPackageFinishBatchDialog
}
